module.exports = __webpack_public_path__ + "static/media/Ben-ProbstWB.18489702.jpg";